/**
 * Выбор источника для показателей, которые обычно приходят из «Мониторинга СНП».
 *
 * У таких показателей (`snp_source` в ответе формы) есть два режима: оставить
 * источник как есть либо перейти на ручной ввод. Пока выбран мониторинг, поле
 * заблокировано — так под работающим источником не появляются «теневые»
 * значения, введённые вручную (US-08, «Fallback, а не перезапись»).
 *
 * **Выбор хранит сервер** — таблица `source_mode`, ключ «показатель × КАТО ×
 * год × регион»; форма присылает его в `manual_mode`, меняет
 * `setSourceMode`. Раньше он лежал в `localStorage` браузера, и это давало три
 * расхождения сразу: выбор не переживал смену устройства, не был виден коллеге
 * по той же территории и — главное — ключом был только код показателя, поэтому
 * переключение по одному району переключало его же во всех остальных
 * территориях региона.
 */
import type { PassportForm } from '../../../requests/input_data.request';

export type { SourceMode } from '../../../requests/input_data.request';

/**
 * Ключи (показателей и блоков), переведённые на ручной ввод, — из ответа формы.
 *
 * Показатель без источника (`snp_source` пуст) в набор не попадает: у него нет
 * тумблера, и он редактируется всегда — см. `FieldsCard`.
 */
export const manualKeysOf = (form: PassportForm): Set<string> => {
  const keys = new Set<string>();
  for (const section of form.sections) {
    for (const field of section.fields) {
      if (field.manual_mode) keys.add(field.key);
    }
    for (const block of section.blocks) {
      if (block.manual_mode) keys.add(block.id);
    }
  }
  return keys;
};
